import React from "react";
import { TextField } from "material-ui";
import juration from "juration";

/**
 * Display duration input fields in a user-friendly "xx hours, xyz minutes, etc..." format while
 * persisting in milliseconds. A thin wrapper around material-ui's <TextField/>.
 */
class DurationField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editedValue: null
    };

    this._handleInputChange = this._handleInputChange.bind(this);
    this._handleInputBlur = this._handleInputBlur.bind(this);
  }

  _handleInputChange(e) {
    let { value } = e.target;

    this.setState({
      editedValue: value
    });

    try {
      let finalValue = juration.parse(value) * 1000; // juration outputs in seconds
      this.props.onChange({
        target: {
          value: finalValue
        }
      });
    } catch (e) {
      // Swallow parse errors
    }
  }

  _handleInputBlur() {
    this.setState({ editedValue: null });
  }

  render() {
    let { value, onChange, onBlur, placeholder, ...props } = this.props,
      { editedValue } = this.state;

    return (
      <TextField
        value={
          editedValue !== null
            ? editedValue
            : juration.stringify(value / 1000) ||
              (placeholder ? "" : "0 seconds")
        } // juration takes seconds as input
        onChange={this._handleInputChange}
        onBlur={this._handleInputBlur}
        placeholder={placeholder}
        {...props}
      />
    );
  }
}

export default DurationField;



// WEBPACK FOOTER //
// ./src/app/components/partials/duration-field.jsx